export type WorkspacePageProps = {
  workspaceId: string;
};

export const WorkspacePage = ({ workspaceId }: WorkspacePageProps) => {
  return <div>Workspace Page</div>;
};
